'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');

const SampleComponent = ({ text }) => {
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: text
  });
};
SampleComponent.displayName = "Tempi Sample";

exports.SampleComponent = SampleComponent;
